var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "bg-red md:rounded-[40px] flex flex-col lg:flex-row overflow-hidden",
      class: { "max-w-[800px] mx-auto justify-center": _vm.type === "slim" }
    },
    [
      _c(
        "form-base",
        {
          ref: "contactForm",
          staticClass: "w-full p-24 lg:p-60 ",
          on: { submit: _vm.submitForm }
        },
        [
          _c(
            "h2",
            {
              staticClass:
                "text-white font-default uppercase text-32 font-extraBold mb-8"
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "mb-24 text-white font-medium prose link-white",
            class: { "!mb-40": _vm.type === "slim" },
            domProps: { innerHTML: _vm._s(_vm.content) }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "grid grid-cols-1 gap-8 lg:gap-32 mb-8 lg:mb-32 w-full",
              class: { "lg:grid-cols-2 ": _vm.type === "default" }
            },
            [
              _c(
                "div",
                { staticClass: "grid grid-cols-1 gap-8 lg:gap-32" },
                [
                  _c("form-input", {
                    attrs: { name: "first_name", rules: "required" },
                    model: {
                      value: _vm.payload.first_name,
                      callback: function($$v) {
                        _vm.$set(_vm.payload, "first_name", $$v)
                      },
                      expression: "payload.first_name"
                    }
                  }),
                  _vm._v(" "),
                  _vm.estateContact == "true"
                    ? _c("form-input", {
                        attrs: { name: "last_name", rules: "required" },
                        model: {
                          value: _vm.payload.last_name,
                          callback: function($$v) {
                            _vm.$set(_vm.payload, "last_name", $$v)
                          },
                          expression: "payload.last_name"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("form-input", {
                    attrs: { name: "email", rules: "required|email" },
                    model: {
                      value: _vm.payload.email,
                      callback: function($$v) {
                        _vm.$set(_vm.payload, "email", $$v)
                      },
                      expression: "payload.email"
                    }
                  }),
                  _vm._v(" "),
                  _c("form-input", {
                    attrs: { name: "phone", rules: "required" },
                    model: {
                      value: _vm.payload.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.payload, "phone", $$v)
                      },
                      expression: "payload.phone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("form-input", {
                class: { "lg:min-h-[303px]": _vm.type === "default" },
                attrs: { type: "textarea", name: "message", rules: "required" },
                model: {
                  value: _vm.payload.message,
                  callback: function($$v) {
                    _vm.$set(_vm.payload, "message", $$v)
                  },
                  expression: "payload.message"
                }
              }),
              _vm._v(" "),
              _c(
                "form-checkbox",
                {
                  attrs: {
                    name: "privacy_policy",
                    rules: { required: { allowFalse: false } }
                  }
                },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("Ik ga akkoord met de "),
                    _c("a", { attrs: { href: "/privacy-policy" } }, [
                      _vm._v("privacyvoorwaarden")
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.type === "default"
        ? _c(
            "div",
            {
              staticClass:
                "hidden lg:block h-[160px] lg:h-auto lg:w-[240px] flex-none relative"
            },
            [
              _c("div", {
                staticClass:
                  "dot lg:w-[30px] lg:h-[15px] lg:rounded-br-[60px] lg:rounded-bl-[60px] w-[15px] h-[30px] rounded-tr-[60px] rounded-br-[60px] lg:rounded-tr-0  bg-white absolute top-[35px] lg:top-0 z-20"
              }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "dot lg:w-[30px] lg:h-[15px] lg:rounded-tr-[60px] lg:rounded-tl-[60px] w-[15px] h-[30px] rounded-tl-[60px] rounded-bl-[60px] lg:rounded-bl-0 bg-white absolute top-[35px] right-0 lg:right-auto lg:top-auto lg:bottom-0 z-20"
              }),
              _vm._v(" "),
              _c("h2", {
                staticClass:
                  "w-[220px] side-banner absolute right-0 top-16 text-white text-20 font-extraBold rotate-90 text-uppercase",
                domProps: { innerHTML: _vm._s(_vm.translatedLabel) }
              }),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.svg(
                      "rocket",
                      " w-[220px] absolute bottom-0 opacity-90 right-0"
                    )
                  )
                }
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "absolute h-full w-[3px] hidden lg:flex flex-col justify-between left-[15px] py-[40px]"
      },
      [
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" }),
        _vm._v(" "),
        _c("span", { staticClass: "h-[12px] block w-full bg-black" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }